import { ThunkAction, ThunkDispatch as Dispatch } from "redux-thunk";

import { Actions } from "./types";
import { ACTION_TYPES } from "./constants";
import { GetState, RootState } from "../store";
import { State } from "../types";
import { MintName as SolanaMintName } from "../config/solana.types";
import { WalletAdapter, WalletAdapterName } from "../adapters/WalletAdapter";

async function getSolanaTokenBalances(
  walletAdapter: WalletAdapter,
  mintNames: SolanaMintName[]
) {
  const balances = await Promise.all(
    mintNames.map(async (mintName) => {
      const balance = await window.__UXD__.solana.services.UXD.getTokenBalance(
        walletAdapter,
        mintName
      );

      const { decimals } = window.__UXD__.solana.config.getMintInfo(mintName);

      const newBalance =
        balance !== null
          ? Math.floor(balance * 10 ** (decimals - 1)) / 10 ** (decimals - 1)
          : null;

      return newBalance;
    })
  );
  return balances;
}

export const getBalanceAction =
  (
    ...tokens: SolanaMintName[]
  ): ThunkAction<void, RootState, void, Actions.SetBalance> =>
  async (
    dispatch: Dispatch<State, void, Actions.SetBalance>,
    getState: GetState
  ): Promise<void> => {
    const walletAdapterName = ((state: State) => state.wallet)(getState());

    if (!walletAdapterName) {
      throw new Error("Missing wallet in `state.wallet`.");
    }

    let getBalancesFunction = (): ReturnType<typeof getSolanaTokenBalances> => {
      throw new Error("Unreachable");
    };
    switch (window.__UXD__.config.chain) {
      case "solana":
      default: {
        const walletAdapter = window.__UXD__.solana.config.getWalletAdapter(
          walletAdapterName as WalletAdapterName
        );
        getBalancesFunction = getSolanaTokenBalances.bind(
          null,
          walletAdapter,
          tokens as SolanaMintName[]
        );
      }
    }

    const balances = await getBalancesFunction();
    const payload = tokens.reduce((acc, token, index) => {
      acc[token] = balances[index];

      return acc;
    }, {} as Actions.SetBalance["payload"]);

    dispatch({
      type: ACTION_TYPES.SET_BALANCE,
      payload,
    });
  };
